import React, { useRef, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Printer, ArrowLeft, Download } from 'lucide-react';
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { getBookingDetails, addBookingDetails, updateBookingDetails } from '@/redux/Booking/actions';
import { getAddressAPI } from '@/redux/Purchase/actions';
import {
    getCountryList, getDocumentTypePurchaseList, getDocumentTypeSalesList, getIncoTermsList, getQuantityTypeList, getSalesPersonList, getUomTypeList, getCommodityGroup, getContainerType, GetOperator, getMoveType, GetCurrencyList, GetChargeBasisList, getUomList,
    getFileManagerList, getMasterCompanyDetails,
    getClauselist
} from "@/redux/Common/actions";
import { loaderStart, loaderStop } from '@/redux/Loader/actions';
import { buildBookingPrintDocumentHtml } from './bookingPrintDocumentHtml';
import { baseURL } from '@/config/APIConfig';
import { axiosInstance } from '@/config/NetworkUtility';

const HEADER_BG = '#1e4d8c';

const BookingPrint = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { countryList, documentTypePurchaseList, documentTypeSalesList, incoTermsList, quantityTypeList, salesPersonList, uomTypeList,
        commodityGroupList, containerTypeList, operatorList, moveTypeList, currency_list, charges_basis_list, MasterCompanyDetails } = useSelector((state) => state.common);

    const { id: encodedId } = useParams();
    const bookingid = atob(encodedId);

    const [formData, setFormData] = useState(null);
    const [chargesByContainer, setChargesByContainer] = useState([]);
    const [containerTypes, setContainerTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const printRef = useRef();
    const [customerAddress, setCustomerAddress] = useState();
    const [authUser] = JSON.parse(localStorage.getItem('authUser') ?? "[{}]");
    const [arCharges, setArCharges] = useState([]);
    const [apCharges, setApCharges] = useState([]);
    const [clauses, setClauses] = useState([]);

    const authName = authUser?.username;
    const companyId = authUser?.companyId;

    const mockData = {
        "statuscode": 200,
        "status": "Request processed successfully.",
        "message": "Records retrieved successfully.",
        "data": {
            "totalNum": 0,
            "rowNum": 0,
            "id": 11,
            "companyId": 1,
            "customerId": 101,
            "customerName": "Pa EXPORTS",
            "contactName": "it Sharma",
            "telephone": "9876543210",
            "fax": "123-456-7890",
            "email": "abc@exports.com",
            "operatorId": 10,
            "operatorName": "VISHAL",
            "blModeId": 1,
            "blMode": "SEA",
            "officeTypeId": 2,
            "officeType": "HEAD OFFICE",
            "fileNumber": "SHIPZ01260011",
            "carrierBookingNumber": "CBN12345",
            "customerReference": "REF-555",
            "shippingType": "FCL",
            "salesOrder": "SO-2025",
            "shipment": "Shipment-001",
            "carrierB": "CB-001",
            "invoice": "INV-123",
            "shipperId": 201,
            "shipper": "Global Shippers Pvt Ltd",
            "shipperAddress": "Some Shipper Address",
            "notifyId": 301,
            "notify": "Notify Party Pvt Ltd",
            "notifyAddress": "Notify Address",
            "consigneeId": 401,
            "consignee": "Consignee Pvt Ltd",
            "consigneeAddress": "Consignee Full Address",
            "alsoNotifyId": 501,
            "alsoNotify": "Also Notify Co.",
            "alsoNotifyAddress": "Also Notify Address",
            "carrierMoveType": "CY-CY",
            "ourMoveType": "DOOR-DOOR",
            "ourPlaceOfReceipt": "MUNDRA",
            "carrierPlaceOfReceipt": "MUNDRA",
            "portOfLoading": "MUNDRA PORT",
            "portOfLoadingCode": "INMUN",
            "portOfDischarge": "JEBEL ALI",
            "portOfDischargeCode": "AEJEA",
            "carrierPlaceOfDelivery": "JEBEL ALI",
            "ourPlaceOfDelivery": "DUBAI",
            "countryOfDestination": "UAE",
            "carrier": "MAERSK",
            "carrierCode": "MSK",
            "hodeCarrier": false,
            "carrierContractNumber": "CON-445",
            "vessel": "MV MAERSK SUN",
            "vesselCode": "VSL0011",
            "voyage": "VOY123",
            "voyageCode": "VC123",
            "ourDocCo": "2025-01-01T00:00:00",
            "vgmCo": "2025-01-02T00:00:00",
            "sslDocCo": "2025-01-03T00:00:00",
            "earliestPickupDate": "2025-01-04T00:00:00",
            "earliestRecvdDate": "2025-01-05T00:00:00",
            "autoCo": "2025-01-06T00:00:00",
            "titleCutOff": "2025-01-07T00:00:00",
            "inlandEailCo": "2025-01-08T00:00:00",
            "portCo": "2025-01-09T00:00:00",
            "etsAtOrigin": "2025-01-10T00:00:00",
            "etsAtPol": "2025-01-11T00:00:00",
            "etaAtPod": "2025-01-12T00:00:00",
            "etaAtDestination": "2025-01-13T00:00:00",
            "commodityGroupId": 901,
            "commodityGroup": "GENERAL GOODS",
            "commodity": "ELECTRONICS",
            "hsCodes": "8471",
            "hazCargo": false,
            "hazImoClass": "",
            "hazPkg": "",
            "hazUnNbr": "",
            "weight": 25000.5,
            "weightMetricId": 1,
            "weightMetricType": "KG",
            "clausesType": "STANDARD",
            "documentRequestToCustomer": false,
            "showAutoBoatClause": false,
            "containerCount": 2,
            "containerTypeId": 1,
            "containerType": "40HC",
            "reeferContainerTemperature": 0,
            "tempUom": "",
            "ventStatus": "CLOSED",
            "ventRemark": "",
            "reeferEquipmentAttributes": "",
            "railTrackingRequired": false,
            "paymentModeType": "PREPAID",
            "paymentMode": "CASH",
            "truckerId": 701,
            "trucker": "XYZ Logistics",
            "hideTruckerOnBookingPrint": false,
            "truckerApptConfirmed": true,
            "rateAgreed": "YES",
            "rateAgreedForWaiting": "NO",
            "truckerContainerCount": 2,
            "truckerContainerTypeId": 1,
            "truckerContainerType": "40HC",
            "truckerEmptyContainerPickupId": 801,
            "truckerEmptyContainerPickup": "Pickup Yard",
            "truckerEmptyContainerPickupAddress": "Pickup Address",
            "truckerEarliestPickup": "2025-01-03T00:00:00",
            "truckerEarliestRecvd": "2025-01-04T00:00:00",
            "truckerLatestDeliveryDate": "2025-01-05T00:00:00",
            "truckerContainerReturnToId": 901,
            "truckerContainerReturnTo": "Return Depot",
            "truckerContainerReturnToAddress": "Return Depot Address",
            "cargoDescription": "Electronics & accessories",
            "warehouseInstructionsRemarks": "Handle with care",
            "loadingStatus": "PENDING",
            "liveLoadDate": "2025-01-06T00:00:00",
            "dropDate": "2025-01-07T00:00:00",
            "pickupDate": "2025-01-08T00:00:00",
            "loadingLocationWarehouseId": 1001,
            "loadingLocationWarehouse": "Main Warehouse",
            "loadingLocationWarehouseAddress": "Warehouse Address",
            "loadingLocationWarehouseContactPerson": "Mr. Kumar",
            "loadingLocationWarehouseTelFax": "1234567890",
            "loadingRemarksForTrucker": "Be on time",
            "truckerPoc": "Anil",
            "truckerPhone": "987654321",
            "truckerEmail": "anil@logistics.com",
            "overseasAgentId": 2001,
            "overseasAgent": "Dubai Cargo",
            "overseasAgentAddress": "Dubai Address",
            "overseasAgentRemarks": "Deliver urgently",
            "customerRemarks": "Customer remarks test",
            "internalRemarks": "Internal notes here",
            "sslRemarks": "SSL client remarks",
            "rubberStamp": "STAMPED",
            "createdBy": "SYSTEM",
            "createdOn": "2026-01-13T09:56:32.34",
            "modifiedOn": "2026-01-15T06:00:53.63",
            "modifiedBy": "SYSTEM",
            "isActive": true,
            "loadPlanId": 111,
            "loadPlanNumber": "LP-2025-111",
            "warehouseId": 12,
            "warehouseName": "WarehouseName",
            "warehouseCode": "WarehouseCode",
            "warehouseAddress": "WarehouseAddress",
            "warehouseContact": "WarehouseContact",
            "receivingDate": "2025-01-06T00:00:00",
            "receivingTime": "18:25",
            "appointmentNumber": "gfsd24562345",
            "specialInstructions": "34523452345",
            "letterOfCreditNumber": "LetterOfCreditNumber",
            "lcIssueDate": "2025-01-06T00:00:00",
            "lcExpiryDate": "2025-01-06T00:00:00",
            "insurancePolicyNumber": "InsurancePolicyNumber",
            "insuranceCompany": "InsuranceCompany",
            "additionalNotes": "AdditionalNotes",
            "totalPackageType": 13,
            "packageType": "pallet",
            "rates": [
                {
                    "rateId": 22,
                    "bookingId": 11,
                    "allIn": true,
                    "descriptions": "FREIGHT CHARGES",
                    "currency": "USD",
                    "roe": 83.25,
                    "basis": "PER CONTAINER",
                    "contType": "40HC",
                    "quantity": 2,
                    "sellAmount": 2000,
                    "sellRate": 1000,
                    "vendorId": 3001,
                    "vendorName": "Vendor 1",
                    "chrgBillToPartyId": 4001,
                    "chrgBillToPartyName": "Billing Party 1",
                    "buyAmount": 1800,
                    "buyRate": 900,
                    "paymentMode": "CASH",
                    "descCode": "FRT",
                    "isDeleted": false,
                    "printOnBl": true,
                    "printOnMbl": true,
                    "officeTypeAr": "HO",
                    "officeTypeAp": "HO",
                    "isCustAdditionalRate": 0,
                    "isDisputeAr": false,
                    "isDisputeAp": false,
                    "arPaid": false,
                    "apPaid": false,
                    "inventoryNumber": "INV-1001"
                },
                {
                    "rateId": 23,
                    "bookingId": 11,
                    "allIn": false,
                    "descriptions": "THC CHARGES",
                    "currency": "INR",
                    "roe": 1,
                    "basis": "PER BL",
                    "contType": "",
                    "quantity": 1,
                    "sellAmount": 15000,
                    "sellRate": 15000,
                    "vendorId": 3002,
                    "vendorName": "Vendor 2",
                    "chrgBillToPartyId": 4002,
                    "chrgBillToPartyName": "Billing Party 2",
                    "buyAmount": 14000,
                    "buyRate": 14000,
                    "paymentMode": "CREDIT",
                    "descCode": "THC",
                    "isDeleted": false,
                    "printOnBl": false,
                    "printOnMbl": false,
                    "officeTypeAr": "BRANCH",
                    "officeTypeAp": "BRANCH",
                    "isCustAdditionalRate": 1,
                    "isDisputeAr": false,
                    "isDisputeAp": false,
                    "arPaid": false,
                    "apPaid": false,
                    "inventoryNumber": "INV-1002"
                },
                {
                    "rateId": 24,
                    "bookingId": 11,
                    "allIn": true,
                    "descriptions": "OTHERS - DOCUMENTATION",
                    "currency": "USD",
                    "roe": 83.25,
                    "basis": "PER BL",
                    "contType": "",
                    "quantity": 1,
                    "sellAmount": 50,
                    "sellRate": 50,
                    "vendorId": 3003,
                    "vendorName": "Vendor 3",
                    "chrgBillToPartyId": 4003,
                    "chrgBillToPartyName": "Billing Party 3",
                    "buyAmount": 40,
                    "buyRate": 40,
                    "paymentMode": "CASH",
                    "descCode": "DOC",
                    "isDeleted": false,
                    "printOnBl": true,
                    "printOnMbl": false,
                    "officeTypeAr": "HO",
                    "officeTypeAp": "HO",
                    "isCustAdditionalRate": 0,
                    "isDisputeAr": false,
                    "isDisputeAp": false,
                    "arPaid": false,
                    "apPaid": false,
                    "inventoryNumber": "INV-1003"
                }
            ],
            "transhipmentPorts": [
                {
                    "transPortId": 22,
                    "bookingId": 11,
                    "transPortCity": "china",
                    "transEta": "2025-01-15T00:00:00",
                    "transActualDeparture": "2025-01-16T00:00:00",
                    "transVessel": "MV SEALAND",
                    "transEtd": "2025-01-17T00:00:00",
                    "transVoyage": "SG123",
                    "transActualArrival": "2025-01-18T00:00:00",
                    "isDeleted": false
                }
            ],
            "cargoDimensionDetails": [
                {
                    "cargoDimensionId": 9,
                    "bookingId": 11,
                    "piece": 1,
                    "length": 1,
                    "width": 1,
                    "height": 1,
                    "packageType": "test",
                    "dimensionType": "METER",
                    "cbm": 1,
                    "cft": 35.31,
                    "weightKgs": 1,
                    "weightLbs": 2.2
                },
                {
                    "cargoDimensionId": 10,
                    "bookingId": 11,
                    "piece": 12,
                    "length": 12,
                    "width": 12,
                    "height": 12,
                    "packageType": "test",
                    "dimensionType": "METER",
                    "cbm": 12,
                    "cft": 352.31,
                    "weightKgs": 12,
                    "weightLbs": 22.2
                }
            ],
            "clauses": [
                { "id": 1, "bookingId": 11, "clausesTypeDescriptionId": 2, "isActive": true },
                { "id": 2, "bookingId": 11, "clausesTypeDescriptionId": 3, "isActive": true }
            ]
        }
    };

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            try {
                if (bookingid && bookingid !== 0) {
                    loadCommonData();
                } else {
                    await _setNewBooking();
                }
            } catch (error) {
                console.error("Error initializing booking:", error);
                await _setNewBooking();
            } finally {
                setLoading(false);
            }
        };
        init();
    }, [bookingid]);

    const loadCommonData = async () => {
        dispatch(getMasterCompanyDetails(authUser?.companyId));
        _getBooking();
    };

    const _getBooking = async () => {
        try {
            let response;
            if (typeof bookingid === 'number' || (typeof bookingid === 'string' && bookingid !== '0')) {
                response = await dispatch(getBookingDetails(bookingid, companyId));
                _setAddress('customer', response?.customerId);
                if (response) {
                    setFormData(response);
                    processRates(response);
                    await getClauselistData(response?.clauses || []);
                } else {
                    await _setNewBooking();
                }
            } else if (bookingid && typeof bookingid === 'object') {
                setFormData(bookingid);
                processRates(bookingid);
            }
        } catch (error) {
            console.error("Error fetching booking:", error);
            await _setNewBooking();
        }
    };

    const getClauselistData = async (formClauses = []) => {
        try {
            const payload = { IPageNo: 1, IPageRecords: 1000, Type: 3 };
            const clauseData = await dispatch(getClauselist(payload));
            const transformedData = clauseData
                .filter(item => formClauses.some(fc => fc.clausesTypeDescriptionId === item.ClauseTypeDescriptionID))
                .map(item => ({
                    ClauseTypeDescriptionID: item.ClauseTypeDescriptionID,
                    ClauseType: item.ClauseType,
                    ClauseDescription: item.ClauseDescription,
                    applied: false,
                    id: null,
                    bookingId: null,
                }));
            setClauses(transformedData);
        } catch (error) { }
    };

    const _setAddress = async (type, id) => {
        const address = await getAddressAPI(id);
        setCustomerAddress(address);
    };

    const _setNewBooking = async () => {
        if (mockData?.data) {
            setFormData(mockData.data);
            processRates(mockData.data);
        }
    };

    const processRates = (data) => {
        if (!data) { setContainerTypes([]); setChargesByContainer({}); return; }
        const ar = Array.isArray(data.arCharges) ? data.arCharges : [];
        const ap = Array.isArray(data.apCharges) ? data.apCharges : [];
        const normalizedAR = ar.map(item => ({
            type: 'AR', description: item.description || '', basis: item.basis || '',
            quantity: Number(item.quantity || 0), container: item.container?.trim() || "GENERAL",
            rate: Number(item.sellRate || 0), amount: Number(item.amount || 0)
        }));
        const normalizedAP = ap.filter(item => Number(item.amount) > 0).map(item => ({
            type: 'AP', description: item.description || '', basis: item.basis || '',
            quantity: Number(item.quantity || 0), container: item.container?.trim() || "GENERAL",
            rate: Number(item.buyRate || 0), amount: Number(item.amount || 0)
        }));
        const allCharges = [...normalizedAR, ...normalizedAP];
        const uniqueContTypes = [...new Set(allCharges.map(i => i.container))];
        const grouped = {};
        uniqueContTypes.forEach(cont => {
            grouped[cont] = {
                AR: allCharges.filter(i => i.container === cont && i.type === 'AR'),
                AP: allCharges.filter(i => i.container === cont && i.type === 'AP')
            };
        });
        setContainerTypes(uniqueContTypes);
        setChargesByContainer(grouped);
    };

    // ─── PRINT FUNCTION - Direct browser print ──────────────────────────────────
    const handlePrint = () => {
        const printContent = printRef.current.cloneNode(true);

        // Create a complete HTML document for printing
        const printWindow = window.open('', '_blank');

        printWindow.document.write(
            buildBookingPrintDocumentHtml(
                printContent.outerHTML,
                formData?.fileNumber || 'Booking',
                HEADER_BG
            )
        );

        printWindow.document.close();
        printWindow.focus();

        // Same delay as PDF iframe so Tailwind CDN + images match download output
        setTimeout(() => {
            printWindow.print();
            printWindow.onafterprint = () => {
                printWindow.close();
            };
        }, 900);
    };

    const waitImagesLoaded = async (root) => {
        const images = root.querySelectorAll('img');
        await Promise.all(Array.from(images).map((img) => {
            if (img.complete) return Promise.resolve();
            return new Promise((resolve) => {
                img.onload = resolve;
                img.onerror = resolve;
                setTimeout(resolve, 2000);
            });
        }));
    };

    const blobToDataUrl = (blob) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });

    /** Absolute URL for API-hosted assets (logos often need Bearer). */
    const resolveImageRequestUrl = (src) => {
        if (!src || src.startsWith('data:')) return src;
        const t = String(src).trim();
        if (/^https?:\/\//i.test(t)) return t;
        if (t.startsWith('//')) return `${window.location.protocol}${t}`;
        if (t.startsWith('/')) {
            try {
                return new URL(t, window.location.href).href;
            } catch {
                /* fall through to API base */
            }
        }
        const base = baseURL.live.replace(/\/?$/, '/');
        const path = t.startsWith('/') ? t.slice(1) : t;
        return `${base}${path}`;
    };

    /** Load remote image as data URL (Bearer for API files + fetch fallback). */
    const fetchImageAsDataUrl = async (src) => {
        if (!src || src.startsWith('data:')) return src || null;
        const requestUrl = resolveImageRequestUrl(src);
        const token = localStorage.getItem('authToken');
        const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

        try {
            const { data } = await axiosInstance({
                method: 'get',
                url: requestUrl,
                responseType: 'blob',
                headers: { ...authHeaders }
            });
            if (data && data.size !== undefined && data.size === 0) return null;
            if (data) return await blobToDataUrl(data);
        } catch {
            /* try fetch */
        }

        let href = requestUrl;
        try {
            href = new URL(requestUrl, window.location.href).href;
        } catch {
            /* keep */
        }
        try {
            const res = await fetch(href, {
                mode: 'cors',
                credentials: 'include',
                headers: { ...authHeaders },
                cache: 'force-cache'
            });
            if (!res.ok) return null;
            return await blobToDataUrl(await res.blob());
        } catch {
            return null;
        }
    };

    /** Copy pixels from an already-loaded on-screen img (works for same-origin only). */
    const tryDrawLiveImageToDataUrl = (liveImg) => {
        if (!liveImg || !liveImg.complete || !(liveImg.naturalWidth > 0)) return null;
        try {
            const c = document.createElement('canvas');
            c.width = liveImg.naturalWidth;
            c.height = liveImg.naturalHeight;
            c.getContext('2d').drawImage(liveImg, 0, 0);
            return c.toDataURL('image/png');
        } catch {
            return null;
        }
    };

    /** Replace <img src> with data URLs so html2canvas always paints logos in PDF. */
    const inlineImagesForBookingPdf = async (cloneRoot, liveRoot) => {
        const cloneImgs = cloneRoot.querySelectorAll('img');
        const liveImgs = liveRoot.querySelectorAll('img');
        await Promise.all(
            Array.from(cloneImgs).map(async (cImg, i) => {
                const live = liveImgs[i];
                const src =
                    (live && (live.currentSrc || live.getAttribute('src'))) ||
                    cImg.getAttribute('src') ||
                    '';
                if (!src || src.startsWith('data:')) return;
                let dataUrl = tryDrawLiveImageToDataUrl(live);
                if (!dataUrl) dataUrl = await fetchImageAsDataUrl(src);
                if (dataUrl && String(dataUrl).startsWith('data:')) {
                    cImg.setAttribute('src', dataUrl);
                }
            })
        );
    };

    /** Scale raster so header/body/footer share one pixel width (avoids misaligned columns on PDF page 2+). */
    const scaleCanvasToWidth = (source, targetWidth) => {
        if (!source || source.width === targetWidth) return source;
        const tw = Math.max(1, Math.round(targetWidth));
        const th = Math.max(1, Math.round(source.height * (tw / source.width)));
        const c = document.createElement('canvas');
        c.width = tw;
        c.height = th;
        const ctx = c.getContext('2d');
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(source, 0, 0, source.width, source.height, 0, 0, tw, th);
        return c;
    };

    /** Renders the same HTML/CSS as the Print dialog in a hidden iframe, then rasterizes layers (matches print design). */
    const captureBookingPdfLayersFromPrintShell = async (printRootOuterHtml, documentTitle) => {
        const iframe = document.createElement('iframe');
        iframe.setAttribute('aria-hidden', 'true');
        iframe.style.cssText =
            'position:fixed;left:-12000px;top:0;width:210mm;min-width:794px;height:12000px;min-height:12000px;border:0;opacity:0;pointer-events:none;overflow:auto';
        document.body.appendChild(iframe);
        try {
            const idoc = iframe.contentDocument;
            const win = idoc.defaultView;
            idoc.open();
            idoc.write(buildBookingPrintDocumentHtml(printRootOuterHtml, documentTitle, HEADER_BG));
            idoc.close();

            await new Promise((r) => setTimeout(r, 900));
            await waitImagesLoaded(idoc.body);
            await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));

            const headerCell = idoc.querySelector('.booking-print-header-cell');
            const bodyCell = idoc.querySelector('.booking-print-body-cell');
            const footerCell = idoc.querySelector('.booking-print-footer-cell');
            if (!headerCell || !bodyCell || !footerCell) {
                throw new Error('Print layout regions not found');
            }

            const scrollH = Math.max(
                idoc.documentElement?.scrollHeight || 0,
                idoc.body?.scrollHeight || 0,
                win?.innerHeight || 0
            );
            const canvasOpts = {
                scale: 3,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff',
                windowWidth: win.innerWidth,
                windowHeight: scrollH
            };

            // Sequential capture avoids iframe/layout races and keeps one consistent scale pass.
            const headerCanvas = await html2canvas(headerCell, canvasOpts);
            const bodyCanvas = await html2canvas(bodyCell, canvasOpts);
            const footerCanvas = await html2canvas(footerCell, canvasOpts);

            const refW = bodyCanvas.width;
            const headerNorm = scaleCanvasToWidth(headerCanvas, refW);
            const footerNorm = scaleCanvasToWidth(footerCanvas, refW);

            return { headerCanvas: headerNorm, bodyCanvas, footerCanvas: footerNorm };
        } finally {
            iframe.remove();
        }
    };

    // ─── DOWNLOAD PDF FUNCTION - Same visual shell as Print ────────────────────
    const handleDownload = async () => {
        if (!printRef.current || !formData) return;

        const downloadBtn = document.querySelector('[data-download-btn]');
        if (downloadBtn) {
            downloadBtn.textContent = 'Generating PDF…';
            downloadBtn.disabled = true;
        }

        try {
            const printRoot = printRef.current.cloneNode(true);
            await inlineImagesForBookingPdf(printRoot, printRef.current);
            const { headerCanvas, bodyCanvas, footerCanvas } = await captureBookingPdfLayersFromPrintShell(
                printRoot.outerHTML,
                formData?.fileNumber || 'Booking'
            );

            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const margin = 8;
            const mmWidth = pdfWidth - margin * 2;

            const toMm = (c) => c.height * (mmWidth / c.width);
            const headerMm = toMm(headerCanvas);
            const footerMm = toMm(footerCanvas);
            const bodyTotalMm = toMm(bodyCanvas);

            const yFooter = pdfHeight - margin - footerMm + 0.5;
            const yBodyStart = margin + headerMm;
            const availableBodyMm = Math.max(1, yFooter - yBodyStart);
            const pxPerMmBody = bodyCanvas.height / bodyTotalMm;

            const headerData = headerCanvas.toDataURL('image/png');
            const footerData = footerCanvas.toDataURL('image/png');

            let yPx = 0;
            let pageIndex = 0;
            const bodyH = bodyCanvas.height;
            while (yPx < bodyH - 0.25) {
                if (pageIndex > 0) pdf.addPage();
                const remainingPx = bodyH - yPx;
                const maxSlicePx = availableBodyMm * pxPerMmBody;
                const slicePx = Math.min(maxSlicePx, remainingPx);

                const sliceCanvas = document.createElement('canvas');
                sliceCanvas.width = bodyCanvas.width;
                sliceCanvas.height = slicePx;
                const ctx = sliceCanvas.getContext('2d');
                ctx.drawImage(bodyCanvas, 0, yPx, bodyCanvas.width, slicePx, 0, 0, bodyCanvas.width, slicePx);
                const sliceData = sliceCanvas.toDataURL('image/png');
                const sliceMm = slicePx * (mmWidth / bodyCanvas.width);

                pdf.addImage(headerData, 'PNG', margin, margin, mmWidth, headerMm);
                pdf.addImage(sliceData, 'PNG', margin, yBodyStart, mmWidth, sliceMm);
                pdf.addImage(footerData, 'PNG', margin, yFooter, mmWidth, footerMm);

                yPx += slicePx;
                pageIndex++;
            }

            pdf.save(`Booking_${formData.fileNumber || 'Document'}_${moment().format('YYYY-MM-DD')}.pdf`);
        } catch (error) {
            console.error('Error generating PDF:', error);
            alert('Failed to generate PDF. Please try printing instead.');
        } finally {
            if (downloadBtn) {
                downloadBtn.textContent = 'Download PDF';
                downloadBtn.disabled = false;
            }
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        return moment(dateString).isValid() ? moment(dateString).format('DD MMM YYYY') : '';
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return '';
        return moment(dateString).isValid() ? moment(dateString).format('DD MMM YYYY HH:mm') : '';
    };

    if (loading || !formData) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100">
                <div className="text-center">
                    <div className="w-12 h-12 border-4 border-blue-900 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                    <p className="text-gray-600">Loading booking data…</p>
                </div>
            </div>
        );
    }

    const SectionHeader = ({ title }) => (
        <div className="px-3 py-1" style={{ backgroundColor: HEADER_BG }}>
            <h3 className="font-bold text-xs uppercase tracking-wide text-white">{title}</h3>
        </div>
    );

    return (
        <div className="min-h-screen bg-gray-200 print:bg-white">
            {/* Action Bar */}
            <div className="print:hidden bg-white shadow-sm border-b border-gray-300 sticky top-0 z-10">
                <div className="max-w-4xl mx-auto px-4 py-2 flex items-center justify-center gap-3">
                    <button
                        onClick={handlePrint}
                        data-download-btn
                        className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-all font-medium border border-gray-300 text-sm"
                    >
                        <Download className="w-4 h-4" />
                        Download PDF
                    </button>
                    <button
                        onClick={handlePrint}
                        className="flex items-center gap-2 px-5 py-2 text-white rounded-lg transition-all font-medium text-sm"
                        style={{ backgroundColor: HEADER_BG }}
                    >
                        <Printer className="w-4 h-4" />
                        Print
                    </button>
                </div>
            </div>

            {/* A4 Print Container */}
            <div className="flex justify-center py-4 print:py-0">
                <div ref={printRef} className="a4-page bg-white shadow-xl print:shadow-none" style={{ width: '210mm', minHeight: '297mm' }}>

                    <table className="booking-print-table w-full" style={{ borderCollapse: 'collapse', width: '100%' }}>
                        <thead className="booking-print-thead">
                            <tr>
                                <td className="booking-print-header-cell p-0 align-top border-none" style={{ border: 'none' }}>
                                    {/* Logo | title | address (same pattern as rate quotation print) */}
                                    <div
                                        className="booking-print-header-wrap bg-white px-4 pt-3 pb-2"
                                        style={{ borderBottom: '1px solid #d1d5db' }}
                                    >
                                        <table
                                            className="booking-print-header-inner w-full border-collapse"
                                            style={{
                                                width: '100%',
                                                tableLayout: 'fixed',
                                                borderCollapse: 'collapse',
                                            }}
                                        >
                                            <tbody>
                                                <tr>
                                                    <td
                                                        className="align-middle"
                                                        style={{
                                                            width: '28%',
                                                            verticalAlign: 'middle',
                                                            padding: '4px 8px 4px 0',
                                                        }}
                                                    >
                                                        <img
                                                            className="booking-print-header-logo block h-10 w-auto max-w-[140px] object-contain object-left"
                                                            src={
                                                                MasterCompanyDetails?.[0]?.CompanyLogoDark ||
                                                                MasterCompanyDetails?.[0]?.CompanyLogo ||
                                                                '/shipez-logo.png'
                                                            }
                                                            alt={MasterCompanyDetails?.[0]?.CompanyName || 'Company Logo'}
                                                        />
                                                    </td>
                                                    <td
                                                        className="align-middle text-center"
                                                        style={{
                                                            width: '44%',
                                                            verticalAlign: 'middle',
                                                            padding: '4px 8px',
                                                        }}
                                                    >
                                                        <h2
                                                            className="booking-print-doc-title m-0 text-center text-sm font-bold uppercase tracking-wide sm:text-base"
                                                            style={{ color: HEADER_BG }}
                                                        >
                                                            Booking Confirmation
                                                        </h2>
                                                    </td>
                                                    <td
                                                        className="align-top text-right"
                                                        style={{
                                                            width: '28%',
                                                            verticalAlign: 'top',
                                                            padding: '4px 0 4px 8px',
                                                        }}
                                                    >
                                                        <div className="booking-print-header-address text-right text-xs leading-tight text-gray-600">
                                                            {MasterCompanyDetails?.[0]?.ProfileAddressPrint
                                                                ?.split(',')
                                                                ?.map((line, i) => (
                                                                    <p key={i} className="m-0">
                                                                        {line.trim()}
                                                                    </p>
                                                                ))}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </thead>

                        <tbody className="booking-print-tbody">
                            <tr>
                                <td className="booking-print-body-cell p-0 align-top border-none" style={{ border: 'none' }}>
                                    <div className="booking-print-gutter py-2 space-y-0">

                                        {/* 1. Booking Confirmation */}
                                        <div className="border border-gray-400 no-break">
                                            <SectionHeader title="Booking Confirmation" />
                                            <div className="grid grid-cols-2">
                                                <div className="p-2 text-xs">
                                                    {customerAddress && customerAddress.length > 0 ? (
                                                        <div className="text-gray-700 leading-snug">
                                                            {customerAddress.split('\r\n').map((line, i) => <p key={i}>{line}</p>)}
                                                        </div>
                                                    ) : (
                                                        <div className="leading-snug text-gray-700">
                                                            <p className="font-medium">{formData?.customerName || ''}</p>
                                                            <p>Contact: {formData?.contactName || ''}</p>
                                                            <p>TEL: {formData?.telephone || ''}</p>
                                                            <p>Email: {formData?.email || ''}</p>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="p-2 border-l border-gray-400">
                                                    <table className="w-full text-xs">
                                                        <tbody>
                                                            {[
                                                                ['BOOKING NO.', formData?.carrierBookingNumber],
                                                                ['FILE No.', formData?.fileNumber],
                                                                ['CREATED DATE', formatDateTime(formData?.createdOn)],
                                                                ['SHIPPING TYPE', formData?.shippingType],
                                                                ['OPERATOR', formData?.file],
                                                            ].map(([label, val]) => (
                                                                <tr key={label}>
                                                                    <td className="text-gray-600 font-medium w-32 py-0.5">{label}</td>
                                                                    <td className="text-gray-900 py-0.5">: {val || ' '}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        {/* 2. Routing & Vessel */}
                                        <div className="border border-gray-400 border-t-0 no-break">
                                            <SectionHeader title="Routing & Vessel Details" />
                                            <div className="grid grid-cols-2 divide-x divide-gray-400">
                                                <div className="p-2">
                                                    <table className="w-full text-xs">
                                                        <tbody>
                                                            {[
                                                                ['CARRIER', formData?.carrier],
                                                                ['VESSEL/VOYAGE', `${formData?.vessel || ''}/${formData?.voyage || ''}`],
                                                                ['MOVE TYPE', formData?.ourMoveType?.split('[')[0]?.trim()],
                                                                ['DOOR/ORIGIN/ZIP', formData?.ourPlaceOfReceipt?.split('[')[0]?.trim()],
                                                                ['PORT OF LOAD', formData?.portOfLoading?.split('[')[0]?.trim()],
                                                                ['TRANSHIPMENT PORT', formData?.transhipmentPorts?.[0]?.transPortCity?.split('[')[0]?.trim()],
                                                                ['PORT OF DISCHARGE', formData?.portOfDischarge?.split('[')[0]?.trim()],
                                                                ['FINAL DESTINATION', formData?.ourPlaceOfDelivery?.split('[')[0]?.trim()],
                                                            ].map(([label, val]) => (
                                                                <tr key={label}>
                                                                    <td className="py-0.5 text-gray-600 font-medium w-36 align-top">{label}</td>
                                                                    <td className="py-0.5 text-gray-900">: {val || ' '}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="p-2">
                                                    <table className="w-full text-xs">
                                                        <tbody>
                                                            {[
                                                                ['EARLIEST RETURN DATE', formatDateTime(formData?.earliestRecvdDate)],
                                                                ['DOC CUTOFF', formatDateTime(formData?.ourDocCo)],
                                                                ['VGM CUTOFF', formatDateTime(formData?.vgmCo)],
                                                                ['RAIL CUTOFF', formatDateTime(formData?.inlandEailCo)],
                                                                ['AUTO CUTOFF', formatDateTime(formData?.autoCo)],
                                                                ['PORT CUTOFF', formatDateTime(formData?.portCo)],
                                                                ['ETD POL', formatDateTime(formData?.etsAtPol)],
                                                                ['ETA POD', formatDateTime(formData?.etaAtPod)],
                                                                ['ETA DESTINATION', formatDateTime(formData?.etaAtDestination)],
                                                            ].map(([label, val]) => (
                                                                <tr key={label}>
                                                                    <td className="py-0.5 text-gray-600 font-medium w-36 align-top">{label}</td>
                                                                    <td className="py-0.5 text-gray-900">: {val || ' '}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        {/* 3. Cargo Details */}
                                        <div className="border border-gray-400 border-t-0 no-break">
                                            <SectionHeader title="Cargo Details" />
                                            <div className="grid grid-cols-2 divide-x divide-gray-400">
                                                <div className="p-2">
                                                    <table className="w-full text-xs">
                                                        <tbody>
                                                            {formData.totalPackageType > 0 && formData?.cargoDimensionDetails
                                                                ?.filter(item => Number(item?.piece) > 0)
                                                                .map((item, i) => (
                                                                    <tr key={i}>
                                                                        <td className="py-0.5 text-gray-700">
                                                                            {item.piece} {item.packageType?.toUpperCase()}(S) /{' '}
                                                                            {Number(item.length).toFixed(2)} X {Number(item.width).toFixed(2)} X {Number(item.height).toFixed(2)}{' '}
                                                                            {item.dimensionType} /{' '}
                                                                            {Number(item.weightKgs).toFixed(2)} KGS /{' '}
                                                                            {Number(item.cbm).toFixed(2)} CBM
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="p-2">
                                                    <p className="text-xs text-gray-700">{formData?.commodity}</p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* 4. Equipment */}
                                        <div className="border border-gray-400 border-t-0 no-break">
                                            <SectionHeader title="Equipment" />
                                            <div className="grid grid-cols-2 divide-x divide-gray-400">
                                                <div className="p-2">
                                                    <p className="text-xs text-gray-900">{formData?.containerCount + 'x' + formData?.containerType}</p>
                                                </div>
                                                <div className="p-2">
                                                    <table className="w-full text-xs table-fixed">
                                                        <tbody>
                                                            {formData?.reeferContainerTemperature != null && (
                                                                <tr>
                                                                    <td className="w-1/2 text-gray-600 py-0.5">REEFER CONT. (TEMP.)</td>
                                                                    <td className="w-1/2 text-gray-900 py-0.5">: {formData?.reeferContainerTemperature}{formData?.tempUom}</td>
                                                                </tr>
                                                            )}
                                                            {[
                                                                ['HAZARDOUS', formData?.hazCargo ? 'Yes' : 'No'],
                                                                ['IMO NO', formData?.hazImoClass ?? ''],
                                                                ['PKG', formData?.hazPkg ?? ''],
                                                                ['UN NBR', formData?.hazUnNbr ?? ''],
                                                            ].map(([label, val]) => (
                                                                <tr key={label}>
                                                                    <td className="w-1/2 text-gray-600 font-medium py-0.5">{label}</td>
                                                                    <td className="w-1/2 text-gray-900 py-0.5">: {val}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        {/* 5. Domestic Routing */}
                                        <div className="border border-gray-400 border-t-0 no-break">
                                            <SectionHeader title="Domestic Routing" />
                                            <div className="grid grid-cols-2 divide-x divide-gray-400">
                                                <div className="p-2">
                                                    <table className="w-full text-xs">
                                                        <tbody>
                                                            {[
                                                                ['PICKUP TERMINAL', formData?.carrierPlaceOfReceipt?.split('[')[0]?.trim()],
                                                                ['EARLIEST PICK-UP DATE', formatDate(formData?.earliestPickupDate)],
                                                            ].map(([label, val]) => (
                                                                <tr key={label}>
                                                                    <td className="py-0.5 text-gray-600 font-medium w-40 align-top">{label}</td>
                                                                    <td className="py-0.5 text-gray-900">: {val || ' '}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="p-2">
                                                    <table className="w-full text-xs">
                                                        <tbody>
                                                            {[
                                                                ['DELIVERY TERMINAL', formData?.carrierPlaceOfDelivery],
                                                                ['EARLIEST RETURN DATE', formatDate(formData?.truckerLatestDeliveryDate)],
                                                            ].map(([label, val]) => (
                                                                <tr key={label}>
                                                                    <td className="py-0.5 text-gray-600 font-medium w-40 align-top">{label}</td>
                                                                    <td className="py-0.5 text-gray-900">: {val || ' '}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <div className="border-t border-gray-300" />

                                            <div className="grid grid-cols-2 divide-x divide-gray-400">
                                                <div className="p-2">
                                                    <table className="w-full text-xs">
                                                        <tbody>
                                                            {[
                                                                ['LOADING LOCATION', formData?.loadingLocationWarehouse],
                                                                ['LIVE LOAD', formData?.loadingStatus],
                                                                ['DROP DATE', formatDate(formData?.dropDate)],
                                                                ['PICKUP DATE', formatDate(formData?.pickupDate)],
                                                            ].map(([label, val]) => (
                                                                <tr key={label}>
                                                                    <td className="py-0.5 text-gray-600 font-medium w-40 align-top">{label}</td>
                                                                    <td className="py-0.5 text-gray-900">: {val || ' '}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="p-2">
                                                    <table className="w-full text-xs">
                                                        <tbody>
                                                            {[
                                                                ['TRUCKER/INLAND CARRIER', formData?.trucker],
                                                                ['CTC TRUCKER', formData?.truckerPoc],
                                                            ].map(([label, val]) => (
                                                                <tr key={label}>
                                                                    <td className="py-0.5 text-gray-600 font-medium w-40 align-top">{label}</td>
                                                                    <td className="py-0.5 text-gray-900">: {val || ' '}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        {/* 6. Charges Summary */}
                                        <div className="border border-gray-400 border-t-0 no-break">
                                            <SectionHeader title="Charges Summary" />
                                            {(() => {
                                                let totalArAll = 0;
                                                containerTypes.forEach(ct => {
                                                    totalArAll += (chargesByContainer[ct]?.AR || []).reduce((s, i) => s + (i.amount || 0), 0);
                                                });
                                                return (
                                                    <>
                                                        {containerTypes.map((containerType, idx) => {
                                                            const arList = chargesByContainer[containerType]?.AR || [];
                                                            if (arList.length === 0) return null;
                                                            const arTotal = arList.reduce((s, i) => s + (i.amount || 0), 0);
                                                            return (
                                                                <div key={idx}>
                                                                    {containerType !== "GENERAL" && (
                                                                        <div className="bg-gray-100 px-3 py-0.5 border-b border-gray-300">
                                                                            <span className="font-semibold text-xs text-gray-700">Container: {containerType}</span>
                                                                        </div>
                                                                    )}
                                                                    <table className="w-full text-xs border-collapse">
                                                                        <thead>
                                                                            <tr className="bg-green-50">
                                                                                <th colSpan="6" className="text-left px-3 py-1 font-semibold text-green-800 border-b border-green-200 text-xs">
                                                                                    AR Charges (Sell)
                                                                                </th>
                                                                            </tr>
                                                                            <tr className="bg-gray-50">
                                                                                {['Description', 'Basis', 'Qty', 'Container', 'Rate', 'Amount'].map(h => (
                                                                                    <th key={h} className={`px-2 py-1 font-semibold text-gray-700 border-b text-xs ${h === 'Qty' || h === 'Rate' || h === 'Amount' ? 'text-right' : 'text-left'}`}>{h}</th>
                                                                                ))}
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {arList.map((item, i) => (
                                                                                <tr key={i} className="hover:bg-gray-50">
                                                                                    <td className="px-2 py-0.5 border-b text-gray-800">{item.description || '-'}</td>
                                                                                    <td className="px-2 py-0.5 border-b text-gray-600">{item.basis || '-'}</td>
                                                                                    <td className="px-2 py-0.5 border-b text-right text-gray-600">{item.quantity?.toLocaleString() || '0'}</td>
                                                                                    <td className="px-2 py-0.5 border-b text-gray-600">{item.container === "GENERAL" ? "-" : item.container}</td>
                                                                                    <td className="px-2 py-0.5 border-b text-right text-gray-700">{item.rate?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}</td>
                                                                                    <td className="px-2 py-0.5 border-b text-right font-medium text-gray-900">{item.amount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}</td>
                                                                                </tr>
                                                                            ))}
                                                                            <tr className="bg-green-50">
                                                                                <td colSpan="5" className="px-2 py-1 text-right font-semibold text-green-800 text-xs">Subtotal:</td>
                                                                                <td className="px-2 py-1 text-right font-bold text-green-800 text-xs">{arTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    {idx < containerTypes.length - 1 && <div className="border-t border-gray-300 my-1" />}
                                                                </div>
                                                            );
                                                        })}

                                                        {totalArAll > 0 && (
                                                            <div className="px-3 py-2 border-t-2 bg-blue-50 flex justify-end">
                                                                <div className="text-right">
                                                                    <span className="font-semibold text-xs text-gray-700">Total AR (Sell):</span>
                                                                    <div className="font-bold text-green-600 text-sm">
                                                                        {totalArAll.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {containerTypes.length === 0 && (
                                                            <div className="p-4 text-center text-gray-500 text-xs">No charges data available</div>
                                                        )}
                                                    </>
                                                );
                                            })()}
                                        </div>

                                        {/* 7. Clause Sections */}
                                        {clauses?.length > 0 && (
                                            <div className="border border-gray-400 border-t-0 no-break">
                                                <SectionHeader title="Clause Sections" />
                                                <div className="p-2">
                                                    {clauses.map((item, i) => (
                                                        <div key={item.ClauseTypeDescriptionID || i} className="flex mb-1">
                                                            <span className="text-xs text-gray-600 mr-2 shrink-0">{i + 1}.</span>
                                                            <p className="text-xs text-gray-600 whitespace-pre-line leading-snug">{item.ClauseDescription}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot className="booking-print-tfoot">
                            <tr>
                                <td className="booking-print-footer-cell p-0 align-top border-none" style={{ border: 'none' }}>
                                    <div className="booking-print-footer-inner booking-print-gutter no-break">
                                        <div className="grid grid-cols-2 booking-print-footer-grid">
                                            <div className="booking-print-footer-stack text-xs text-gray-700">
                                                <p className="text-gray-500">Prepared By:</p>
                                                <p className="font-semibold text-gray-900">{formData?.createdBy || ' '}</p>
                                                <p className="text-gray-600">{MasterCompanyDetails?.[0]?.CompanyName} – {formData?.officeType || ' '}</p>
                                                <p className="text-gray-500">Date: {formatDateTime(formData?.createdOn)}</p>
                                            </div>
                                            <div className="booking-print-footer-stack text-xs text-right">
                                                <p className="text-gray-500">Customer Acceptance:</p>
                                                <div className="border-b border-gray-400 w-44 booking-print-footer-sigline ml-auto"></div>
                                                <p className="text-gray-500">Authorized Signature & Date</p>
                                            </div>
                                        </div>
                                        <div className="booking-print-footer-note text-center">
                                            <p className="text-xs text-gray-500">
                                                This is a computer generated document. No signature required. | Thank you for choosing {MasterCompanyDetails?.[0]?.CompanyName}
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

            <style>{`
                .booking-print-gutter {
                    padding-left: 1rem;
                    padding-right: 1rem;
                    box-sizing: border-box;
                }

                .booking-print-header-address p {
                    margin: 0;
                    line-height: 1.25;
                }

                .booking-print-doc-title {
                    color: #1e4d8c;
                }

                img.booking-print-header-logo {
                    max-width: 140px;
                    object-fit: contain;
                }

                table.booking-print-header-inner td {
                    background-color: #fff;
                }

                .booking-print-footer-inner {
                    margin-top: 4px;
                    padding-top: 4px;
                    border-top: 1px solid #d1d5db;
                    line-height: 1.25;
                }

                .booking-print-footer-grid {
                    column-gap: 10px;
                    row-gap: 0;
                }

                .booking-print-footer-stack {
                    display: flex;
                    flex-direction: column;
                    gap: 3px;
                }

                .booking-print-footer-stack p {
                    margin: 0;
                    line-height: 1.25;
                }

                .booking-print-footer-sigline {
                    height: 14px;
                    margin-top: 2px;
                    margin-bottom: 2px;
                }

                .booking-print-footer-note {
                    margin-top: 6px;
                    padding-top: 4px;
                    border-top: 1px solid #e5e7eb;
                }

                .booking-print-footer-note p {
                    margin: 0;
                    line-height: 1.35;
                }

                @media print {
                    @page { 
                        size: A4; 
                        margin: 8mm;
                    }
                    
                    body {
                        margin: 0;
                        padding: 0;
                        background: white;
                    }

                    .a4-page,
                    .a4-page * {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                    
                    .a4-page {
                        margin: 0;
                        padding: 0;
                        box-shadow: none;
                        min-height: 0 !important;
                    }

                    .booking-print-doc-title {
                        color: #1e4d8c !important;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }

                    img.booking-print-header-logo {
                        max-width: 132px !important;
                        max-height: 48px !important;
                        width: auto !important;
                        height: auto !important;
                        object-fit: contain !important;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }

                    table.booking-print-header-inner td {
                        background-color: #fff !important;
                    }

                    .booking-print-table {
                        width: 100%;
                        border-collapse: collapse;
                    }

                    thead.booking-print-thead {
                        display: table-header-group;
                    }

                    tfoot.booking-print-tfoot {
                        display: table-footer-group;
                    }
                    
                    .no-break { 
                        page-break-inside: avoid; 
                        break-inside: avoid; 
                    }
                    
                    .print\\:hidden {
                        display: none !important;
                    }
                    
                    .print\\:py-0 {
                        padding-top: 0 !important;
                        padding-bottom: 0 !important;
                    }
                    
                    .print\\:shadow-none {
                        box-shadow: none !important;
                    }
                    
                    .print\\:bg-white {
                        background: white !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default BookingPrint;